import React from 'react';
import { action, observable, makeAutoObservable } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { WithdrawalPendingRowState } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/WithdrawalPendingRow/WithdrawalPendingRow.state';
import {
    ApproveFormWrapper,
    ButtonWrapper,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/FormApprove/FormApprove.style';
import { Dropdown } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/Dropdown/Dropdown';
import {
    DROPDOWN_AMOUNT_OPTIONS_FIAT,
    DROPDOWN_AMOUNT_OPTIONS_BTC,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/SelectionOptions';
import { Amount } from 'src_common/common/amount/Amount';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

interface FormApprovePropsType {
    state: WithdrawalPendingRowState;
    currency: string;
}

class State {
    @observable isDisabled: boolean = true;

    private readonly withdrawalPendingRowState: WithdrawalPendingRowState;
    public readonly amountValue: FormInputState<string, Amount>;

    public constructor(withdrawalPendingRowState: WithdrawalPendingRowState) {
        this.withdrawalPendingRowState = withdrawalPendingRowState;

        this.amountValue = FormInputState.new('').map((newAmount) => {
            if (newAmount === '') {
                return Result.createError('Incorrect number');
            }

            try {
                const convertedNewAmount = new Amount(newAmount);

                if (convertedNewAmount.isLessThanZero() || convertedNewAmount.isEqualWith(new Amount('0'))) {
                    return Result.createError('Incorrect number');
                }

                return Result.createOk(convertedNewAmount);
            } catch (error) {
                return Result.createError('Incorrect number');
            }
        });
        makeAutoObservable(this);
    }

    public onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const amount = new Amount(event.target.value);
        this.amountValue.setValue(amount.value);
        this.isDisabled = amount.isEqualWith(new Amount('0'));
    };

    @action public onSubmit = async (): Promise<void> => {
        const amount = this.amountValue.value;
        await this.withdrawalPendingRowState.onSetRule({
            ruleType: 'approve',
            amount,
            reason: null,
        });
    };
}

export const FormApprove = observer('FormApprove', (props: FormApprovePropsType): React.ReactElement => {
    const { state: withdrawalPendingRowState, currency } = props;
    const [state] = React.useState(() => new State(withdrawalPendingRowState));

    return (
        <ApproveFormWrapper>
            <Dropdown
                onChange={state.onChange}
                dropDownvalue={state.amountValue.value ?? ''}
                options={currency === 'BTC' ? DROPDOWN_AMOUNT_OPTIONS_BTC : DROPDOWN_AMOUNT_OPTIONS_FIAT}
                currency={currency}
                placeholder='Select amount...'
                dataTest='approve-dropdown'
            />
            <ButtonWrapper
                btnColor='confirm'
                onClick={state.onSubmit}
                isDisabled={state.isDisabled}
                dataTest='approve-button'
            >
                Approve
            </ButtonWrapper>
        </ApproveFormWrapper>
    );
});
